exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-properties{width:0!important;height:0%!important}.danger{background-color:#f5bcc0}", ""]);

// exports
